<template>
  <div class="zhanwei4"></div>
  <div class="container">
    <!-- 顶部状态配置与定价 -->
    <div class="form-group">
      <div class="form-item">
        <label for="visibility">发布类型:</label>
        <el-select
          id="visibility"
          v-model="option"
          placeholder="请选择发布阶段"
          style="width: 160px"
        >
          <el-option label="内测 (无需审核)" value="内测"></el-option>
          <el-option label="公测 (需审核)" value="公测"></el-option>
          <el-option label="正式上线 (需审核)" value="正式上线"></el-option>
        </el-select>
        <span class="status-explain-badge" :class="optionClass">
          {{ optionExplain }}
        </span>
      </div>

      <div class="form-item">
        <label for="price">体验价格:</label>
        <el-input
          id="price"
          v-model="defaultPrice"
          type="number"
          placeholder="0 为免费"
          style="width: 160px"
        >
          <template #append>元</template>
        </el-input>
      </div>
    </div>

    <!-- 核心版本与二维码卡片 -->
    <div class="info-group">
      <el-row :gutter="24">
        <!-- 左侧：正式/公测二维码区 -->
        <el-col :span="11" v-if="form.id != null">
          <div class="qr-panel">
            <div class="qr-header">
              <span class="qr-title">{{ currentVersionTitle }}</span>
              <span class="version-tag">v{{ form.version || 1 }}.0</span>
            </div>
            <div class="qr-code">
              <vue-qr :text="qr_text" :size="200"></vue-qr>
            </div>
            <span class="qr-tip">玩家使用移动端 App 扫码入局</span>
          </div>
        </el-col>

        <!-- 右侧：详尽版本流转状态 -->
        <el-col :span="13" class="info-details">
          <div class="detail-row">
            <span class="label">当前阶段:</span>
            <span class="val phase-tag" :class="currentPhaseClass">
              {{ currentPhaseLabel }}
            </span>
          </div>

          <div class="detail-row">
            <span class="label">审核状态:</span>
            <span class="val status-tag" :class="statusTagClass">
              {{ statusLabel }}
            </span>
          </div>

          <div class="detail-row">
            <span class="label">游玩区域:</span>
            <span class="val">不限地点 / 开放探索</span>
          </div>

          <div class="detail-row" v-if="form.createTime">
            <span class="label">初次创建:</span>
            <span class="val">{{ form.createTime }}</span>
          </div>

          <div class="detail-row" v-if="form.releaseTime">
            <span class="label">生效时间:</span>
            <span class="val">{{ form.releaseTime }}</span>
          </div>

          <!-- 驳回备注提示 -->
          <div class="remark-card" v-if="form.remark">
            <div class="remark-header">
              <el-icon><WarningFilled /></el-icon>
              <span>审核意见/反馈备注</span>
            </div>
            <p class="remark-content">{{ form.remark }}</p>
          </div>
        </el-col>
      </el-row>
    </div>

    <!-- 底部操作与体验通道 -->
    <div class="button-group">
      <el-button
        type="primary"
        class="release-main-btn"
        :loading="publishing"
        @click="releaseGame"
      >
        {{ publishBtnText }}
      </el-button>

      <el-popover
        :width="200"
        placement="top"
        popper-style="box-shadow: 0 10px 30px rgba(15, 23, 42, 0.15); padding: 16px; border-radius: 12px;"
      >
        <template #reference>
          <div class="tiyan">
            <el-icon><Iphone /></el-icon>
            <span>创作者即时体验通道</span>
          </div>
        </template>
        <template #default>
          <div class="demo-rich-content">
            <span class="demo-tip">开发测试专用码</span>
            <vue-qr :text="qr_text2" :size="180"></vue-qr>
            <span class="demo-sub">仅创作者测试设备可扫</span>
          </div>
        </template>
      </el-popover>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import { ElMessage, ElMessageBox } from "element-plus";
import { WarningFilled, Iphone } from "@element-plus/icons-vue";
import vueQr from "vue-qr/src/packages/vue-qr.vue";

export default defineComponent({
  name: "ReleaseManager",
  components: {
    vueQr,
    WarningFilled,
    Iphone,
  },
  data(): any {
    return {
      option: "内测", // '内测' | '公测' | '正式上线'
      gameId: "",
      publishing: false,
      form: {
        id: "",
        publicStatus: 0, // 0: 内测, 2: 公测, 1: 正式上线
        remark: null,
        gameLevelId: "",
        status: 0, // 0: 审核中, 1: 已发布, 2: 审核驳回
        version: 0,
        updateTime: "",
        releaseTime: "",
        createTime: "",
      },
      defaultPrice: 0,
      qr_text: "default",
      qr_text2: "default",
    };
  },
  computed: {
    // 顶部下拉框右侧提示文字
    optionExplain(): string {
      if (this.option === "内测") {
        return "即时发布，无需平台审核";
      } else if (this.option === "公测") {
        return "公开展示，需人工审核";
      }
      return "正式商用，需人工严格审核";
    },
    optionClass(): string {
      if (this.option === "内测") return "tag-green";
      if (this.option === "公测") return "tag-blue";
      return "tag-purple";
    },
    // 主按钮文本提示
    publishBtnText(): string {
      if (this.option === "内测") {
        return "立即发布内测 (免审)";
      }
      return `提交${this.option}审核`;
    },
    currentVersionTitle(): string {
      return this.option === "内测"
        ? "内测体验码"
        : this.option === "公测"
        ? "公测体验码"
        : "正式上线版";
    },
    currentPhaseLabel(): string {
      const ps = this.form.publicStatus;
      if (ps === 0) return "内测阶段 (私密)";
      if (ps === 2) return "公测阶段 (限量)";
      if (ps === 1) return "正式上线 (全网公开)";
      return "待发布";
    },
    currentPhaseClass(): string {
      const ps = this.form.publicStatus;
      if (ps === 0) return "phase-green";
      if (ps === 2) return "phase-blue";
      if (ps === 1) return "phase-purple";
      return "phase-gray";
    },
    // 审核状态文案与样式
    statusLabel(): string {
      // 如果当前为内测模式且已保存过，则直接显示无需审核
      if (this.form.publicStatus === 0) {
        return "内测直通 (免审核)";
      }
      if (this.form.status === 0) return "审核中 · 资料校验";
      if (this.form.status === 1) return "审核通过 · 已发布";
      if (this.form.status === 2) return "审核未通过 · 已驳回";
      return "待提交审核";
    },
    statusTagClass(): string {
      if (this.form.publicStatus === 0) return "status-pass";
      if (this.form.status === 0) return "status-pending";
      if (this.form.status === 1) return "status-pass";
      if (this.form.status === 2) return "status-rejected";
      return "status-draft";
    },
  },
  mounted() {
    const { id } = this.$route.params;
    this.gameId = id as string;
    this.initRelease(this.gameId);
  },
  methods: {
    initRelease(id: string) {
      this.$store
        .dispatch("game/getRelease", { releaseId: id })
        .then((res: any) => {
          if (!res) return;
          res.remark = res.remark === "" ? null : res.remark;
          this.form = res;

          // 映射三种状态：0 -> 内测, 2 -> 公测, 1 -> 正式上线
          if (res.publicStatus === 0) {
            this.option = "内测";
          } else if (res.publicStatus === 2) {
            this.option = "公测";
          } else {
            this.option = "正式上线";
          }

          this.defaultPrice = res.purchaseMoney || 0;
          this.qr_text = `${res.id}&${res.publicStatus}`;
          this.qr_text2 = `${res.id}&test`;
        })
        .catch((err: any) => {
          console.error(err);
        });
    },

    releaseGame() {
      const isInner = this.option === "内测";
      const confirmTip = isInner
        ? "【内测发布】无需官方审核，确认后将立即打包生成最新资源包供玩家直接扫码体验！"
        : `【${this.option}申请】提交后系统将建立资料包并转交官方人工审核（通常需要1个工作日），是否确认提交？`;

      ElMessageBox.confirm(
        confirmTip,
        isInner ? "发布内测版本" : "提交上线审核",
        {
          confirmButtonText: isInner ? "立即发布" : "确认提交",
          cancelButtonText: "取消",
          type: isInner ? "success" : "warning",
        }
      )
        .then(() => {
          this.publishing = true;

          // 核心三态传参转换：内测 = 0, 公测 = 2, 正式上线 = 1
          let statusCode = 0;
          if (this.option === "正式上线") {
            statusCode = 1;
          } else if (this.option === "公测") {
            statusCode = 2;
          } else {
            statusCode = 0;
          }

          this.$store
            .dispatch("game/releaseGame2", {
              gameId: this.gameId,
              price: Math.max(0, Number(this.defaultPrice) || 0),
              publicStatue: statusCode,
            })
            .then((res: any) => {
              if (res) {
                res.remark = res.remark === "" ? null : res.remark;
                this.form = res;
                this.defaultPrice = res.purchaseMoney || 0;
                this.qr_text = `${res.id}&${res.publicStatus}`;
              }
              ElMessage.success(
                isInner
                  ? "内测版本发布成功，资料包已生效"
                  : "已提交审核申请，请留意状态流转"
              );
            })
            .catch((err: any) => {
              ElMessage.error("操作失败: " + (err.message || "系统繁忙"));
            })
            .finally(() => {
              this.publishing = false;
            });
        })
        .catch(() => {});
    },
  },
});
</script>

<style lang="less" scoped>
@primary-color: #5d5fef;
@primary-hover: #4b4de0;
@primary-light: #f0f2ff;
@text-main: #0f172a;
@text-sub: #475569;
@text-muted: #94a3b8;
@border-color: #e2e8f0;
@card-border: #f1f5f9;
@success-color: #10b981;
@warning-color: #f59e0b;
@danger-color: #ef4444;

.zhanwei4 {
  height: 24px;
}

// 主卡片容器
.container {
  max-width: 880px;
  margin: 10px auto 40px;
  padding: 32px 36px;
  background-color: #ffffff;
  border: 1px solid @card-border;
  border-radius: 16px;
  box-shadow: 0 4px 20px -2px rgba(15, 23, 42, 0.04);
  box-sizing: border-box;
}

// 顶部选项栏
.form-group {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 20px;
  padding-bottom: 24px;
  margin-bottom: 24px;
  border-bottom: 1px solid @border-color;

  .form-item {
    display: flex;
    align-items: center;
    gap: 10px;

    label {
      font-size: 13.5px;
      font-weight: 600;
      color: @text-main;
      white-space: nowrap;
    }
  }

  .status-explain-badge {
    font-size: 12px;
    padding: 3px 8px;
    border-radius: 6px;
    font-weight: 500;

    &.tag-green {
      background: #ecfdf5;
      color: @success-color;
      border: 1px solid #a7f3d0;
    }
    &.tag-blue {
      background: #eff6ff;
      color: #3b82f6;
      border: 1px solid #bfdbfe;
    }
    &.tag-purple {
      background: @primary-light;
      color: @primary-color;
      border: 1px solid #dce2ff;
    }
  }

  @media (max-width: 768px) {
    flex-direction: column;
    align-items: flex-start;
  }
}

// 核心信息组展示
.info-group {
  margin-bottom: 32px;

  // 左侧二维码面板
  .qr-panel {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 22px;
    background: #f8fafc;
    border-radius: 14px;
    border: 1px solid @border-color;

    .qr-header {
      width: 100%;
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 14px;

      .qr-title {
        font-size: 14.5px;
        font-weight: 700;
        color: @text-main;
      }
      .version-tag {
        font-size: 11px;
        font-weight: 600;
        color: @primary-color;
        background: @primary-light;
        padding: 2px 7px;
        border-radius: 4px;
      }
    }

    .qr-code {
      display: flex;
      justify-content: center;
      align-items: center;
      padding: 10px;
      background: #ffffff;
      border-radius: 10px;
      box-shadow: 0 4px 12px rgba(15, 23, 42, 0.05);
      border: 1px solid @border-color;
      margin-bottom: 12px;

      img,
      canvas {
        display: block;
        width: 160px !important;
        height: 160px !important;
      }
    }

    .qr-tip {
      font-size: 12px;
      color: @text-muted;
    }
  }

  // 右侧详情信息列表
  .info-details {
    display: flex;
    flex-direction: column;
    justify-content: center;
    gap: 12px;
    padding-left: 20px;

    .detail-row {
      display: flex;
      align-items: center;
      font-size: 13.5px;

      .label {
        width: 84px;
        color: @text-muted;
        font-weight: 500;
        flex-shrink: 0;
      }

      .val {
        color: @text-main;
        font-weight: 600;
      }

      // 阶段与审核状态胶囊
      .phase-tag,
      .status-tag {
        display: inline-block;
        font-size: 12px;
        font-weight: 600;
        padding: 2px 10px;
        border-radius: 20px;
      }

      .phase-green {
        background: #ecfdf5;
        color: @success-color;
      }
      .phase-blue {
        background: #eff6ff;
        color: #3b82f6;
      }
      .phase-purple {
        background: @primary-light;
        color: @primary-color;
      }
      .phase-gray {
        background: #f1f5f9;
        color: @text-muted;
      }

      .status-pass {
        background: #ecfdf5;
        color: @success-color;
      }
      .status-pending {
        background: #fffbeb;
        color: @warning-color;
      }
      .status-rejected {
        background: #fef2f2;
        color: @danger-color;
      }
      .status-draft {
        background: #f1f5f9;
        color: @text-muted;
      }
    }

    // 驳回意见卡片
    .remark-card {
      margin-top: 8px;
      background: #fef2f2;
      border: 1px solid #fecaca;
      border-radius: 8px;
      padding: 10px 14px;

      .remark-header {
        display: flex;
        align-items: center;
        gap: 6px;
        color: @danger-color;
        font-size: 12.5px;
        font-weight: 700;
        margin-bottom: 4px;
      }

      .remark-content {
        margin: 0;
        font-size: 12px;
        color: #991b1b;
        line-height: 1.5;
      }
    }
  }
}

// 底部按钮操作区
.button-group {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
  padding-top: 10px;

  .release-main-btn {
    min-width: 220px;
    height: 44px;
    border-radius: 10px;
    font-size: 14.5px;
    font-weight: 700;
    background: @primary-color;
    border-color: @primary-color;
    box-shadow: 0 4px 14px rgba(93, 95, 239, 0.28);
    transition: all 0.2s ease;

    &:hover {
      background: @primary-hover;
      border-color: @primary-hover;
      transform: translateY(-1px);
      box-shadow: 0 6px 18px rgba(93, 95, 239, 0.38);
    }
  }
}

// 创作者通道胶囊
.tiyan {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 6px 16px;
  background: #f8fafc;
  border: 1px solid @border-color;
  border-radius: 20px;
  cursor: pointer;
  color: @text-sub;
  font-size: 12.5px;
  font-weight: 500;
  transition: all 0.2s ease;

  &:hover {
    background: @primary-light;
    border-color: #dce2ff;
    color: @primary-color;
  }
}

.demo-rich-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  padding: 4px;

  .demo-tip {
    font-size: 12.5px;
    font-weight: 700;
    color: @text-main;
  }

  .demo-sub {
    font-size: 11px;
    color: @text-muted;
  }
}
</style>
